module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(node.CLASS_NAME.indexOf('Descartes.Layer') === 0) { ;
__p += '\n\n	';
 if(fctVisibility) { ;
__p += '\n			<span class="Descartes-visible-stack" title="' +
((__t = (visibleTitle)) == null ? '' : __t) +
'">\n				    <span class="' +
((__t = (visibleClassName)) == null ? '' : __t) +
'"></span>\n				    <span class="' +
((__t = (needZoomClassName)) == null ? '' : __t) +
'"></span>\n				</span>\n	';
};
__p += '\n\n			<span class="indent-2"></span>\n\n    ';
if(fctQueryable || fctOpacity) { ;
__p += '\n		    <a href="#ds-' +
((__t = (node.id)) == null ? '' : __t) +
'" class="DescartesLayersTreeHref" data-toggle="collapse"><span title="' +
((__t = (node.title)) == null ? '' : __t) +
'" class="' +
((__t = (itemTextClassName)) == null ? '' : __t) +
'">' +
((__t = (node.title)) == null ? '' : __t) +
'</span></a>\n	\n		    <div id="ds-' +
((__t = (node.id)) == null ? '' : __t) +
'" class="collapse">	\n                <span class="indent-10"></span><span class="indent-5"></span>\n		        ';
if(fctQueryable) { ;
__p += '\n				<span class="' +
((__t = (queryableClassName)) == null ? '' : __t) +
'" title="' +
((__t = (queryableTitle)) == null ? '' : __t) +
'"></span>\n		        ';
 } ;
__p += '\n			    ';
 if(fctOpacity) { ;
__p += '\n				<span class="indent-2"></span>\n				<span id="' +
((__t = (id)) == null ? '' : __t) +
'_SliderB"></span>\n				<span class="indent-2"></span>\n			    ';
 } ;
__p += '\n				\n			</div>\n	';
 } else {;
__p += '\n	        <span title="' +
((__t = (node.title)) == null ? '' : __t) +
'" class="' +
((__t = (itemTextClassName)) == null ? '' : __t) +
'">' +
((__t = (node.title)) == null ? '' : __t) +
'</span>\n	';
 } ;
__p += '\n\n	         \n	';
 if(fctDisplayLegend && node.isVisible()) {  ;
__p += '\n\n		';
_.each(node.legend,function(legend) {;
__p += '\n			<div>\n				<span class="indent-10"></span><img src="' +
((__t = (legend)) == null ? '' : __t) +
'" class="DescartesLayersTreeLegendImage"/>\n			</div>\n		';
});;
__p += '\n	';
 } ;
__p += '\n	\n';
 } ;


}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/TreeItemSimple.ejs
// module id = 396
// module chunks = 0